import { EntityType } from 'store/entities/types';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { AdminEventSettingsActions } from 'store/actions';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import * as actions from '../actions';

// todo: deal with type conflicts
const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<any>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions & typeof AdminEventSettingsActions>;

const adminOrgEventsAutocompleteReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminOrgEventsAutocomplete.request.type]: actionsHandlers.handleGetPaginatedManyRequest,
  [actions.getAdminOrgEventsAutocomplete.success.type]: actionsHandlers.handleGetPaginatedManySuccess,
  [actions.getAdminOrgEventsAutocomplete.failure.type]: actionsHandlers.handleGetPaginatedManyFailure,
  [actions.getAdminOrgEventsAutocomplete.reset.type]: actionsHandlers.handleGetPaginatedManyReset,
});

export default adminOrgEventsAutocompleteReducer;
